// project import
import dashboard from './dashboard';
import setting from './setting';
import order from './order';
// import orderpage from './order';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, order, setting] //pages, utilities, support
};

export default menuItems;
